import AuthPluginPCBase from '@src/slide/application/no-edit/plugins/auth/base/pc/auth-plugin-pc';
import {
    AuthRightBarModule,
    MODULE_NAME,
} from '@src/slide/application/no-edit/plugins/auth/toc/pc/auth-right-bar-module';
import {
    AuthComponentParams,
    IAuthPluginPC,
} from '@src/slide/application/no-edit/plugins/auth/toc/pc/auth-plugin-pc.interface';
import {
    ISharePluginPC,
} from '@src/slide/application/no-edit/plugins/share/base/pc/share-plugin-pc.interface';
import NoEditArkLoader from '@src/slide/application/no-edit/common/no-edit-ark-extensions';
import { AUTH_EXTENSION_CONFIG } from '@src/slide/application/no-edit/common/no-edit-ark-extensions/dc-components/auth/component-config';
import { SlideDataServices } from '@src/slide/domain/slide-app/core/slide-data-services.core';
import {
    browser,
} from '@src/slide/application/service/edit-extension/edit-extension-export';
import { IExtension } from '@tencent/ark-extensions';
import { SHARE_PC_PLUGIN_NAME } from '@src/slide/application/no-edit/plugins/share/constant';

export default class AuthPluginPC extends AuthPluginPCBase implements IAuthPluginPC {
    private moduleInited: boolean;
    private module: IExtension;

    public initPlugin(): void {
        super.initPlugin();

        this.editExtensionService?.registerRightSideBarModule(new AuthRightBarModule(this));
    }

    public show(params: AuthComponentParams): void {
        this.editExtensionService?.showRightSideBar(MODULE_NAME, params);
    }

    public showModule(params: AuthComponentParams): void {
        const { onShow } = params;
        this.loadModule(() => {
            if (this.module && this.moduleInited) { // 模块已加载，并且已初始化
                this.showAuth({ ...params });
            } else {
                this.initAuth({ ...params });
                this.moduleInited = true;
            }
            onShow?.();
        });
    }

    /**
     * 处理弹框更改有效期按钮回调。子类可重写
     * @protected
     */
    protected handleChangeValidTimeAction() {
        this.show({
            invokeFrom: 'Root',
            showAdvPermissionsCmp: true,
        });
    }

    protected getDomainId(): string | undefined {
        const globalPadId = SlideDataServices.DocInfoManager()?.globalPadId;
        const index = globalPadId?.indexOf('$');
        return globalPadId?.slice(0, index);
    }

    private getSharePlugin(): ISharePluginPC | undefined {
        return this.noEditService?.getPluginSync(SHARE_PC_PLUGIN_NAME);
    }

    /**
     * 拉取权限模块
     * @param {callback} cb
     */
    private loadModule(cb: () => void): void {
        if (this.module) {
            cb?.();
            return;
        }

        NoEditArkLoader.extensionService.getExtension(AUTH_EXTENSION_CONFIG.name)
            .then((module) => {
                this.module = module;
                cb?.();
            })
            .catch((error) => {
                window.log.warn('权限面板加载失败:', error);
            });
    }

    /**
     * 初始化权限模块
     * @param {*} params
     */
    private initAuth(params: AuthComponentParams) {
        const {
            invokeFrom, showAdvPermissionsCmp, DOMNode, authUpdateCallback, authExpTimeUpdated, onClose,
        } = params;
        const { creatorDomain, padId, padType } = SlideDataServices.DocInfoManager() ?? {};
        const domainId = this.getDomainId();

        const userInfo = this.getUserInfo();
        const options = {
            invokeFrom,
            showAdvPermissionsCmp,
            padId,
            owner: {
                name: userInfo?.nick,
                // TODO 这里的头像可能需要判断登录类型，如果是微信，则取微信头像
                avatar: userInfo?.avatar,
                type: 'owner',
                uin: userInfo?.uin,
            },
            domainId,
            creatorDomain,
            shareLink: this.getSharePlugin()?.getShareLink(),
            shareTitle: () => SlideDataServices.SlideTitleManager()?.title,
            shareDocType: padType,
            onAuthUpdated: (info) => {
                this.auth.setAuthInfo(info);
                authUpdateCallback?.(info);
            },
            onClose: (info) => {
                authUpdateCallback?.(info);
                onClose?.();
            },
            onShare: () => {
                // 打开分享模块
                this.showShare();
            },
            onAuthExpTimeUpdated: (info) => {
                authExpTimeUpdated?.(info);
            },
        };

        this.module.show({
            container: DOMNode,
            ...options,
        });
    }

    /**
     * 显示权限模块
     * @param {*} params
     */
    private showAuth(params: AuthComponentParams): void {
        const {
            invokeFrom, showAdvPermissionsCmp, DOMNode, authUpdateCallback, authExpTimeUpdated, onClose,
        } = params;
        this.module.show({
            container: DOMNode,
            showAdvPermissionsCmp,
            onAuthUpdated: (info) => {
                authUpdateCallback?.(info);
            },
            onShare: () => {
                // 打开分享模块
                this.showShare();
            },
            invokeFrom,
            onClose: (info) => {
                authUpdateCallback?.(info);
                onClose?.();
            },
            onAuthExpTimeUpdated: (info) => {
                authExpTimeUpdated?.(info);
            },
        });
    }

    private showShare() {
        // 小程序点击分享文档按钮，跳转到小程序原生分享页面
        if (browser.isMiniProgram) {
            this.getSharePlugin()?.navigateToSharePanel();
        } else {
            this.getSharePlugin()?.show();
        }
    }
}
